module.exports = __webpack_public_path__ + "img/21.487bc129.png";